import React from 'react';
import Icon from '../AppIcon';

const SearchHistory = ({ searches, onApply, onClear }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Icon name="History" size={20} color="#3b82f6" />
          Search History
        </h3>
        {searches?.length > 0 && (
          <button
            onClick={onClear}
            className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium rounded-lg transition-colors"
          >
            Clear
          </button>
        )}
      </div>

      {searches?.length === 0 ? (
        <p className="text-sm text-gray-500 text-center py-4">No search history</p>
      ) : (
        <div className="space-y-2">
          {searches?.map((search) => (
            <button
              key={search?.id}
              onClick={() => onApply(search?.query)}
              className="w-full flex items-center gap-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors text-left"
            >
              <Icon name="Search" size={16} color="#6B7280" />
              <span className="flex-1 text-sm text-gray-700">{search?.query}</span>
              <span className="text-xs text-gray-500">
                {new Date(search?.timestamp)?.toLocaleDateString()}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchHistory;